import type { UsePerimeterConsoAction } from "@components/PerimeterLayout/PerimeterLayout.types";
import { useTenant } from "@contexts/Tenant/Tenant.context";
import { useGetConsumption } from "@services/apiEcms/useGetConsumption";
import { useCustomTranslation } from "@utils/translations/useCustomTranslation";

export const usePerimeterConsoAction = ({
  customerId,
  contractId,
  siteId,
}: UsePerimeterConsoAction) => {
  const { t } = useCustomTranslation(["main", "common"]);
  const { authorizedEnergyType } = useTenant();
  const elecQuery = useGetConsumption({
    energy: "ELEC",
    enabled: authorizedEnergyType === "elec" || authorizedEnergyType === "dual",
    customerId,
    contractId,
    siteId,
    select: ({ data }) => [
      {
        name: t("perimeter.consumptionAction.previousMonth"),
        value: data.previousMonthInKwh
          ? t("numberWithUnit", {
              ns: "common",
              value: data.previousMonthInKwh,
              measurementUnit: "kWh",
            })
          : t("unavailable", { ns: "common" }),
      },
      {
        name: t("perimeter.consumptionAction.currentYear"),
        value: data.currentYearInKwh
          ? t("numberWithUnit", {
              ns: "common",
              value: data.currentYearInKwh,
              measurementUnit: "kWh",
            })
          : t("unavailable", { ns: "common" }),
      },
    ],
  });

  const gasQuery = useGetConsumption({
    energy: "GAS",
    enabled: authorizedEnergyType === "gas" || authorizedEnergyType === "dual",
    customerId,
    contractId,
    siteId,
    select: ({ data }) => [
      {
        name: t("perimeter.consumptionAction.previousMonth"),
        value: data.previousMonthInKwh
          ? t("numberWithUnit", {
              ns: "common",
              value: data.previousMonthInKwh,
              measurementUnit: "kWh",
            })
          : t("unavailable", { ns: "common" }),
      },
      {
        name: t("perimeter.consumptionAction.currentYear"),
        value: data.currentYearInKwh
          ? t("numberWithUnit", {
              ns: "common",
              value: data.currentYearInKwh,
              measurementUnit: "kWh",
            })
          : t("unavailable", { ns: "common" }),
      },
    ],
  });

  const energiesLoading = elecQuery.isFetching || gasQuery.isFetching;

  return {
    elec: elecQuery,
    gas: gasQuery,
    energiesLoading,
  };
};
